// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__ssrVg","load7":"style_load7__UQsop"};